import { HourlyCost, PlugSession, PlugSessions } from '@/types/plugSessions'

// TODO: remove once BE ships /api/plug_sessions/
// Hour-by-hour bars for the TOU session, plugged in 2 PM – 2 AM.
// Sums align exactly with the session's energy_breakdown:
//   off peak     40.1 kWh @ $0.04 = $1.60
//   partial peak 12.2 kWh @ $0.07 = $0.85
//   peak          6.0 kWh @ $0.08 = $0.47  (throttled during peak hours)
//   total        58.3 kWh, $2.92
const TOU_HOURLY_COSTS: HourlyCost[] = [
  {
    hour_starting: '2025-11-10T14:00:00',
    kwh: 5.0,
    cost: 0.2,
    period: 'off_peak',
  },
  {
    hour_starting: '2025-11-10T15:00:00',
    kwh: 4.0,
    cost: 0.28,
    period: 'partial_peak',
  },
  {
    hour_starting: '2025-11-10T16:00:00',
    kwh: 2.0,
    cost: 0.16,
    period: 'peak',
  },
  {
    hour_starting: '2025-11-10T17:00:00',
    kwh: 2.0,
    cost: 0.16,
    period: 'peak',
  },
  {
    hour_starting: '2025-11-10T18:00:00',
    kwh: 2.0,
    cost: 0.15,
    period: 'peak',
  },
  {
    hour_starting: '2025-11-10T19:00:00',
    kwh: 4.1,
    cost: 0.29,
    period: 'partial_peak',
  },
  {
    hour_starting: '2025-11-10T20:00:00',
    kwh: 4.1,
    cost: 0.28,
    period: 'partial_peak',
  },
  {
    hour_starting: '2025-11-10T21:00:00',
    kwh: 5.9,
    cost: 0.24,
    period: 'off_peak',
  },
  {
    hour_starting: '2025-11-10T22:00:00',
    kwh: 5.9,
    cost: 0.24,
    period: 'off_peak',
  },
  {
    hour_starting: '2025-11-10T23:00:00',
    kwh: 5.9,
    cost: 0.24,
    period: 'off_peak',
  },
  {
    hour_starting: '2025-11-11T00:00:00',
    kwh: 5.8,
    cost: 0.23,
    period: 'off_peak',
  },
  {
    hour_starting: '2025-11-11T01:00:00',
    kwh: 5.8,
    cost: 0.23,
    period: 'off_peak',
  },
  {
    hour_starting: '2025-11-11T02:00:00',
    kwh: 5.8,
    cost: 0.22,
    period: 'off_peak',
  },
]

export const MOCK_SESSIONS: PlugSession[] = [
  {
    id: 1,
    vehicle_id: 1,
    start_time: '2025-11-10T14:00:00',
    end_time: '2025-11-11T02:00:00',
    // Matches the hourly chart's charging span (bars 2 PM through the
    // 2 AM hour) so chart, header times, and totals reconcile
    charge_start_time: '2025-11-10T14:05:00',
    charge_end_time: '2025-11-11T02:40:00',
    start_battery_percent: 20,
    end_battery_percent: 72,
    total_cost: 2.92,
    energy_kwh: 58.3,
    charge_rate_kw: 4.9,
    max_charge_rate_kw: 11.5,
    active_charge_rate_kw: 10.9,
    active_charge_seconds: 45300,
    currency: 'USD',
    missed_charge_target: true,
    charge_limit_doomed: true,
    charged_vehicle_name: null,
    charge_target_percent: 80,
    rate_plan_type: 'tou',
    energy_breakdown: [
      {
        period: 'off_peak',
        label: 'off peak',
        kwh: 40.1,
        rate_per_kwh: 0.04,
        cost: 1.6,
      },
      {
        period: 'partial_peak',
        label: 'partial peak',
        kwh: 12.2,
        rate_per_kwh: 0.07,
        cost: 0.85,
      },
      {
        period: 'peak',
        label: 'peak',
        kwh: 6.0,
        rate_per_kwh: 0.08,
        cost: 0.47,
      },
    ],
    hourly_costs: TOU_HOURLY_COSTS,
    ready_by_time: '6:00 AM',
  },
  {
    id: 2,
    vehicle_id: 1,
    start_time: '2025-06-08T20:30:00Z',
    end_time: '2025-06-08T23:30:00Z',
    charge_start_time: '2025-06-08T20:45:00Z',
    charge_end_time: '2025-06-08T23:15:00Z',
    start_battery_percent: 40,
    end_battery_percent: 80,
    total_cost: 1.33,
    energy_kwh: 33.3,
    charge_rate_kw: 11.1,
    max_charge_rate_kw: 11.7,
    active_charge_rate_kw: 11.1,
    active_charge_seconds: 9000,
    currency: 'USD',
    missed_charge_target: false,
    charge_limit_doomed: false,
    charged_vehicle_name: null,
    charge_target_percent: 80,
    rate_plan_type: 'flat',
    energy_breakdown: [
      { period: 'flat', label: '', kwh: 33.3, rate_per_kwh: 0.04, cost: 1.33 },
    ],
    // Flat-rate sessions get the hourly chart too (green bars — uniform
    // pricing classifies as a single off-peak tier). The middle hour's dip
    // mimics a mid-session charging pause.
    hourly_costs: [
      {
        hour_starting: '2025-06-08T20:00:00Z',
        kwh: 12.2,
        cost: 0.49,
        period: 'flat',
      },
      {
        hour_starting: '2025-06-08T21:00:00Z',
        kwh: 3.1,
        cost: 0.12,
        period: 'flat',
      },
      {
        hour_starting: '2025-06-08T22:00:00Z',
        kwh: 11.1,
        cost: 0.44,
        period: 'flat',
      },
      {
        hour_starting: '2025-06-08T23:00:00Z',
        kwh: 6.9,
        cost: 0.28,
        period: 'flat',
      },
    ],
    ready_by_time: null,
  },
  {
    id: 3,
    vehicle_id: 1,
    start_time: '2025-11-08T20:30:00Z',
    end_time: '2025-11-08T23:30:00Z',
    charge_start_time: '2025-11-08T20:40:00Z',
    charge_end_time: '2025-11-08T23:20:00Z',
    start_battery_percent: 40,
    end_battery_percent: 80,
    total_cost: 1.33,
    energy_kwh: 33.3,
    charge_rate_kw: 11.1,
    max_charge_rate_kw: 11.7,
    active_charge_rate_kw: 11.1,
    active_charge_seconds: 9600,
    currency: 'USD',
    missed_charge_target: false,
    charge_limit_doomed: false,
    // Charger-style card: correlated to the customer's car
    charged_vehicle_name: 'Black Panther',
    charge_target_percent: 80,
    rate_plan_type: 'tiered',
    energy_breakdown: [
      { period: 'flat', label: '', kwh: 33.3, rate_per_kwh: 0.04, cost: 1.33 },
    ],
    hourly_costs: null,
    ready_by_time: null,
  },
]

/**
 * Real-time (ComEd-style hourly pricing) session: hours classify by absolute
 * cents/kWh against the Save Money cost-category boundaries [0, 8, 14] —
 * negative < 0c (grid pays you), low 0-8c, medium 8-14c, high > 14c.
 */
export const MOCK_REAL_TIME_SESSION: PlugSession = {
  id: 4,
  vehicle_id: 1,
  start_time: '2026-08-05T22:00:00',
  end_time: '2026-08-06T04:00:00',
  charge_start_time: '2026-08-05T22:30:00',
  charge_end_time: '2026-08-06T03:30:00',
  start_battery_percent: 30,
  end_battery_percent: 74,
  total_cost: 2.02,
  energy_kwh: 33.0,
  charge_rate_kw: 5.5,
  max_charge_rate_kw: 7.7,
  active_charge_rate_kw: 7.2,
  active_charge_seconds: 18000,
  currency: 'USD',
  missed_charge_target: false,
  charge_limit_doomed: false,
  charged_vehicle_name: null,
  charge_target_percent: 80,
  rate_plan_type: 'real_time',
  energy_breakdown: [
    {
      period: 'negative',
      label: 'negative cost',
      kwh: 5.0,
      rate_per_kwh: -0.012,
      cost: -0.06,
    },
    {
      period: 'low',
      label: 'low cost',
      kwh: 17.0,
      rate_per_kwh: 0.045,
      cost: 0.77,
    },
    {
      period: 'medium',
      label: 'medium cost',
      kwh: 6.0,
      rate_per_kwh: 0.11,
      cost: 0.66,
    },
    {
      period: 'high',
      label: 'high cost',
      kwh: 5.0,
      rate_per_kwh: 0.13,
      cost: 0.65,
    },
  ],
  hourly_costs: [
    {
      hour_starting: '2026-08-05T22:00:00',
      kwh: 5.0,
      cost: 0.65,
      period: 'high',
    },
    {
      hour_starting: '2026-08-05T23:00:00',
      kwh: 6.0,
      cost: 0.66,
      period: 'medium',
    },
    {
      hour_starting: '2026-08-06T00:00:00',
      kwh: 6.0,
      cost: 0.3,
      period: 'low',
    },
    {
      hour_starting: '2026-08-06T01:00:00',
      kwh: 5.0,
      cost: -0.06,
      period: 'negative',
    },
    {
      hour_starting: '2026-08-06T02:00:00',
      kwh: 6.0,
      cost: 0.25,
      period: 'low',
    },
    {
      hour_starting: '2026-08-06T03:00:00',
      kwh: 5.0,
      cost: 0.22,
      period: 'low',
    },
  ],
  ready_by_time: null,
}

export const MOCK_DATA: PlugSessions = {
  count: 3,
  next: null,
  previous: null,
  results: MOCK_SESSIONS,
  total_cost: 4.52,
  gas_savings: 18.4,
  // 12h + 3h + 3h plugged in across the three mock sessions
  total_charge_seconds: 18 * 3600,
  // ~5.4h + 3h + 3h of active charging -> avg 3.8h, renders "4 hrs"
  total_active_charge_seconds: 63900,
  total_energy_kwh: 124.9,
  currency: 'USD',
  has_rate_plan: true,
  start_date: '2025-11-08',
  end_date: '2026-03-31',
  total_pages: 1,
  page_number: 1,
}

/** No-rate-plan variant: costs are stripped by the BE, has_rate_plan is false */
export const MOCK_DATA_NO_RATE_PLAN: PlugSessions = {
  ...MOCK_DATA,
  has_rate_plan: false,
  total_cost: null,
  results: MOCK_SESSIONS.map((session) => ({
    ...session,
    total_cost: null,
    rate_plan_type: null,
    energy_breakdown: null,
    hourly_costs: null,
  })),
}

/**
 * Stress-test fixture: a 36-hour Level 1 (~1.4 kW) session spanning two nights,
 * for checking how the TOU detail chart handles many thin bars, repeated TOU
 * cycles, and ambiguous first/last x-axis labels. Not part of MOCK_SESSIONS so
 * the list stories stay untouched.
 */
function buildL1LongSession(): PlugSession {
  const RATE: Record<string, { rate: number; period: HourlyCost['period'] }> = {
    off_peak: { rate: 0.04, period: 'off_peak' },
    partial_peak: { rate: 0.07, period: 'partial_peak' },
    peak: { rate: 0.08, period: 'peak' },
  }
  // Same daily TOU shape as the short mock session: peak 4-7 PM,
  // partial 3-4 PM and 7-9 PM, off peak overnight
  const periodForHour = (hour: number) =>
    hour >= 16 && hour < 19
      ? RATE.peak
      : (hour >= 15 && hour < 16) || (hour >= 19 && hour < 21)
      ? RATE.partial_peak
      : RATE.off_peak

  const KWH_PER_HOUR = 1.4 // Level 1 trickle charge
  const start = new Date('2025-11-10T14:00:00')
  const hourly: HourlyCost[] = Array.from({ length: 36 }, (_, i) => {
    const d = new Date(start.getTime() + i * 3600_000)
    const { rate, period } = periodForHour(d.getHours())
    // Format as a local naive timestamp — toISOString would shift to UTC
    const pad = (n: number) => `${n}`.padStart(2, '0')
    const localStamp = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
      d.getDate(),
    )}T${pad(d.getHours())}:00:00`
    return {
      hour_starting: localStamp,
      kwh: KWH_PER_HOUR,
      cost: +(KWH_PER_HOUR * rate).toFixed(2),
      period,
    }
  })

  const sumBy = (p: string) => hourly.filter((h) => h.period === p)
  const line = (p: 'off_peak' | 'partial_peak' | 'peak', label: string) => ({
    period: p,
    label,
    kwh: +sumBy(p)
      .reduce((a, h) => a + h.kwh, 0)
      .toFixed(1),
    rate_per_kwh: RATE[p].rate,
    cost: +sumBy(p)
      .reduce((a, h) => a + h.cost, 0)
      .toFixed(2),
  })
  const totalCost = +hourly.reduce((a, h) => a + h.cost, 0).toFixed(2)

  return {
    id: 4,
    vehicle_id: 1,
    start_time: '2025-11-10T14:00:00',
    end_time: '2025-11-12T02:00:00',
    charge_start_time: '2025-11-10T14:10:00',
    charge_end_time: '2025-11-12T01:50:00',
    start_battery_percent: 12,
    end_battery_percent: 74,
    total_cost: totalCost,
    energy_kwh: +(KWH_PER_HOUR * 36).toFixed(1),
    charge_rate_kw: 1.4,
    max_charge_rate_kw: 1.7,
    active_charge_rate_kw: 1.4,
    active_charge_seconds: 128400,
    currency: 'USD',
    missed_charge_target: false,
    charge_limit_doomed: false,
    charged_vehicle_name: null,
    charge_target_percent: 80,
    rate_plan_type: 'tou',
    energy_breakdown: [
      line('off_peak', 'off peak'),
      line('partial_peak', 'partial peak'),
      line('peak', 'peak'),
    ],
    hourly_costs: hourly,
    ready_by_time: '6:00 AM',
  }
}

export const MOCK_L1_LONG_SESSION: PlugSession = buildL1LongSession()
